import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      "title": "Bokstavering",
      "tagline": "Learn the phonetic alphabet",
      "input-placeholder": "Write your text here..",
      "swedish": "Swedish",
      "english-nato": "English (NATO)",
      "creator-link-description": "Created by Martin 🤓",
      "nav-spell": "Spell",
      "nav-alphabet": "Alphabet",
      "alphabet-title": "The NATO phonetic alphabet",
      "alphabet-note": "Å, Ä and Ö are not part of the NATO alphabet, so they are spelled as aa, ae and oe.",
      "A": "Alfa",
      "B": "Bravo",
      "C":	"Charlie",
      "D":	"Delta",
      "E":	"Echo",
      "F":	"Foxtrot",
      "G":	"Golf",
      "H":	"Hotel",
      "I":	"India",
      "J":	"Juliett",
      "K":	"Kilo",
      "L":	"Lima",
      "M":	"Mike",
      "N":	"November",
      "O":	"Oscar",
      "P":	"Papa",
      "Q":	"Quebec",
      "R":	"Romeo",
      "S":	"Sierra",
      "T":	"Tango",
      "U":	"Uniform",
      "V":	"Victor",
      "W":	"Whiskey",
      "X":	"Xray",
      "Y":	"Yankee",
      "Z":	"Zulu",
      // Not in NATO; spelled as their transliterations (aa, ae, oe)
      "Å":	"Alfa Alfa",
      "Ä":	"Alfa Echo",
      "Ö":	"Oscar Echo",
    },
  },
  sv: {
    translation: {
      "title": "Bokstavering",
      "tagline": "Lär dig bokstaveringsalfabetet",
      "input-placeholder": "Skriv in din text här..",
      "swedish": "Svenska",
      "english-nato": "Engelska (NATO)",
      "creator-link-description": "Skapad av Martin 🤓",
      "nav-spell": "Bokstavera",
      "nav-alphabet": "Alfabetet",
      "alphabet-title": "Svenska bokstaveringsalfabetet",
      "A": "Adam",
      "B": "Bertil",
      "C": "Cesar",
      "D": "David",
      "E": "Erik",
      "F": "Filip",
      "G": "Gustav",
      "H": "Helge",
      "I": "Ivar",
      "J": "Johan",
      "K": "Kalle",
      "L": "Ludvig",
      "M": "Martin",
      "N": "Niklas",
      "O": "Olle",
      "P": "Petter",
      "Q": "Qvintus",
      "R": "Rudolf",
      "S": "Sigurd",
      "T": "Tore",
      "U": "Urban",
      "V": "Viktor",
      "W": "Wilhelm",
      "X": "Xerxes",
      "Y": "Yngve",
      "Z": "Zäta",
      "Å": "Åke",
      "Ä": "Ärlig",
      "Ö": "Östen",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "sv",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

// Every letter the app can spell, in alphabetical order
export const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZÅÄÖ".split("");

export const changeLanguage = (newLanguage: string | undefined) => {
  i18n.changeLanguage(newLanguage);
};

export default i18n;
